import PropTypes from 'prop-types';
import React, { Component } from 'react';
import IntegrationTextField from '../../fields/TextField';

class ContentIntegrationManagement extends Component {
    renderFields = () => {
        let { schema, model, onChange } = this.props;
        return schema.map((section) => {
            return section.tabFields.map((field) => {
                switch (field.dataType) {
                    case 'text':
                    default:
                        return (
                            <IntegrationTextField
                                value={model[field.id]}
                                field={field}
                                description={field.description}
                                onChange={onChange}
                            />
                        );
                }
            });
        });
    };

    render() {
        let { model } = this.props;
        let renderFields = this.renderFields();
        return <div className="form-fields">{renderFields}</div>;
    }
}
export default ContentIntegrationManagement;
